import { Injectable, computed, inject } from "@angular/core";
import type { WkDataTableInternalData, WkDataTableInternalDataItem } from "@components/data-table/data-table.types";
import { WkDataTableContextService } from "@components/data-table/data-table-context.service";

@Injectable()
export class WkDataTableSelectionService<TItem> {
    private readonly wkDataTableContext = inject<WkDataTableContextService<TItem>>(WkDataTableContextService);

    public readonly selections = computed<WkDataTableInternalData<TItem>>(() => {
        return this.wkDataTableContext.data?.().filter((item) => item.$selected) ?? [];
    });

    public toggleSelect(row: WkDataTableInternalDataItem<TItem> | undefined) {
        if (!row) return;
        this.wkDataTableContext.data?.update((items) => {
            if (!items) return [];

            return items.map((item) => {
                if (item === row) return { ...item, $selected: !item.$selected };

                return item;
            });
        });
    }

    public clearAll() {
        this.wkDataTableContext.data?.update((items) => {
            for (const item of items) {
                if (item.$selected) item.$selected = false;
            }
            const temp = [...items];
            return temp;
        });
    }

    public toggleSelectAll() {
        this.wkDataTableContext.data?.update((items) => {
            const allSelected = items.every((item) => item.$selected);
            return items.map((item) => ({ ...item, $selected: !allSelected }));
        });
    }

    public areAllSelected = computed<boolean>(() => {
        return this.selections().length === this.wkDataTableContext.data?.().length && this.wkDataTableContext.data().length > 0;
    });
}
